import {
  BookOpen, DollarSign, Plus, Type, Layout, Image, FileText, PenTool,
  ListOrdered, AlignLeft, Banknote
} from "lucide-react";

export const API_URL = process.env.REACT_APP_BACKEND_URL + "/api";

export const PAGE_TYPES = [
  { value: "cover", label: "Cover", icon: BookOpen, color: "bg-blue-100 text-blue-700", desc: "Branded cover page" },
  { value: "option", label: "Option", icon: DollarSign, color: "bg-emerald-100 text-emerald-700", desc: "Pricing option with scope" },
  { value: "addon", label: "Add-on", icon: Plus, color: "bg-amber-100 text-amber-700", desc: "Optional upgrade or add-on" },
  { value: "text", label: "Text", icon: Type, color: "bg-slate-100 text-slate-700", desc: "Terms, warranties, info" },
  { value: "custom", label: "Custom", icon: Layout, color: "bg-purple-100 text-purple-700", desc: "Rich content: text, images, video, HTML" },
  { value: "gallery", label: "Gallery", icon: Image, color: "bg-pink-100 text-pink-700", desc: "Photo gallery page" },
  { value: "file", label: "File", icon: FileText, color: "bg-cyan-100 text-cyan-700", desc: "File or PDF attachment" },
  { value: "financing", label: "Financing", icon: Banknote, color: "bg-green-100 text-green-700", desc: "Financing options & prequal links" },
  { value: "signature", label: "Signature", icon: PenTool, color: "bg-orange-100 text-orange-700", desc: "Signature & options summary" },
  { value: "structure", label: "Structure", icon: ListOrdered, color: "bg-indigo-100 text-indigo-700", desc: "Group options (pick one per structure)" },
  { value: "form", label: "Form", icon: AlignLeft, color: "bg-teal-100 text-teal-700", desc: "Customer input form" },
];

export const FONTS = [
  "Inter", "Arial", "Georgia", "Times New Roman", "Verdana",
  "Helvetica", "Courier New", "Trebuchet MS", "Palatino", "Garamond"
];

export const FONT_SIZES = ["10", "12", "14", "16", "18", "20", "24", "28", "32", "36", "42", "48"];

export const DEFAULT_SETTINGS = {
  default_quote_name: "",
  profit_margin: 40,
  deposit_percent: 50,
  rounding: "exact",
  quote_expiration_days: 30,
  send_quote_stage: "",
  partially_signed_stage: "",
  signed_quote_stage: "",
  primary_signer_message: "",
  secondary_signer_message: "",
  auto_send_deposit_invoice: false,
  financing_offer: false,
  financing_text: "",
  discounts: [],
  additional_signers: [],
  show_quote_summary: true,
  attachments: [],
  // Mobile layout: when true, eligible cards (options/add-ons) render in a
  // two-column grid on phones so the quote feels less "skinny and long".
  compact_mobile_layout: false,
};

export const MEASUREMENT_LABELS = {
  total_area: "Field Area (SF)", eaves_rakes: "Eaves+Rakes (w)", eaves_rakes_raw: "Eaves+Rakes",
  hips_ridges: "Hips+Ridges", ridges: "Ridges (LF)", valleys: "Valleys (LF)",
  hips: "Hips (LF)", eaves: "Eaves (LF)", rakes: "Rakes (LF)", boots: "Pipe Boots",
  drip_edge: "Drip Edge (LF)", flashing: "Flashing", osb: "OSB Sheets",
  transitions: "Transitions (LF)", sealant: "Sealant", spray: "Spray",
  delivery: "Delivery", labor_low: "Labor Low", labor_mid: "Labor Mid", labor_high: "Labor High"
};
